import { render } from "./upload-document.vue?vue&type=template&id=6aaa67ca&ts=true"
import script from "./upload-document.vue?vue&type=script&lang=ts"
export * from "./upload-document.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__